module.exports = __webpack_public_path__ + "public/images/program/program-5.a2442866e308500da90095217dd6b03f.png";